import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { PermanentElectricityDisconnectionPage, PermanentElectricityDisconnectionPageProps } from "./PermanentElectricityDisconnectionPage";

export const EMPTY_PAGE_CONTENT: PermanentElectricityDisconnectionPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/disconnections/permanent";

export const PermanentElectricityDisconnectionPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<PermanentElectricityDisconnectionPageProps>(
    "electricity_disconnections___permanent",
    EMPTY_PAGE_CONTENT,
  );
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <PermanentElectricityDisconnectionPage {...routeProps} {...content} />;
};
